import * as TypeGraphQL from "type-graphql";
export var VolatilityLevel;
(function (VolatilityLevel) {
    VolatilityLevel["VERY_LOW"] = "VERY_LOW";
    VolatilityLevel["LOW"] = "LOW";
    VolatilityLevel["MEDIUM"] = "MEDIUM";
    VolatilityLevel["HIGH"] = "HIGH";
    VolatilityLevel["VERY_HIGH"] = "VERY_HIGH";
})(VolatilityLevel || (VolatilityLevel = {}));
TypeGraphQL.registerEnumType(VolatilityLevel, {
    name: "VolatilityLevel",
    description: undefined,
});
//# sourceMappingURL=VolatilityLevel.js.map